import { Injectable } from '@angular/core';
import { SynchronizationEntity } from '../../synchronization/synchronization-entity';
import { LocalDb } from '../local-db';
import { SynchronizationState, SynchronizationStatus } from '../objects/synchronization-status';

@Injectable({ providedIn: 'root' })
export class SynchronizationStatusRepository {
  constructor(private readonly _db: LocalDb) {}

  async updateStatus(entity: SynchronizationEntity, state: SynchronizationState, message?:string): Promise<void> {
    await this._db.synchronizationStatus.put({
      entity,
      synchronizationState: state,
      lastSync: new Date(),
      message: message ?? ''
    });
  }

  async getStatusByEntity(entity: SynchronizationEntity) {
    return this._db.synchronizationStatus.get(entity);
  }

  async getAllStatuses(): Promise<SynchronizationStatus[]> {
    return this._db.synchronizationStatus.toArray();
  }

  async getStatusesByState(state: string): Promise<SynchronizationStatus[]> {
    return this._db.synchronizationStatus.where('synchronizationState').equals(state).toArray();
  }
}
